import React from 'react';
import { Button, Form, FormGroup } from 'reactstrap';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import {
  isRequired,
  validateLength,
  validateNumber,
  validateRuc,
} from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import FormFooter from '../../../common/forms/FormFooter';

const validateLength11 = validateLength(11, 'dígitos');

const EditParcelAccountingDataModalForm = ({
  handleSubmit,
  onCancel,
  initialValues,
}) => {
  const documentCodeField = initialValues.newBusinessName ? (
    <>
      <FormGroup row>
        <FormItem label="Razón Social" required>
          <Field
            name="newBusinessName"
            component={TextInput}
            type="text"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="RUC" required>
          <Field
            name="newBusinessTaxId"
            component={TextInput}
            type="text"
            validate={[
              isRequired,
              validateNumber,
              validateLength11,
              validateRuc,
            ]}
          />
        </FormItem>
      </FormGroup>
    </>
  ) : (
    <FormGroup row>
      <FormItem label="Nro de Dcocumento">
        <Field
          name="idDocumentNumber"
          component={TextInput}
          type="text"
          placeholder="Nùmero de Documento"
          validate={[isRequired, validateNumber]}
        />
      </FormItem>
    </FormGroup>
  );

  return (
    <Form onSubmit={handleSubmit}>
      {documentCodeField}
      <FormGroup row>
        <FormItem label="Comentario">
          <Field
            name="comment"
            component={TextInput}
            type="textarea"
            placeholder="Descripción"
          />
        </FormItem>
      </FormGroup>
      <FormFooter>
        <Button color="primary" onClick={onCancel}>
          Cancelar
        </Button>
      </FormFooter>
    </Form>
  );
};

EditParcelAccountingDataModalForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    newPaymentMethod: PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
      transactionCode: PropTypes.string,
    }),
    voucherCode: PropTypes.string,
    newBusinessName: PropTypes.string,
    newBusinessTaxId: PropTypes.string,
  }).isRequired,
};

export default reduxForm({
  form: 'EditParcelAccountingDataModalForm',
})(EditParcelAccountingDataModalForm);
